/**
 * Symbolic name of the action for resetting a password.
 */
export const PASSWORD_RESET = 'PASSWORD_RESET';

/**
 * Error code indicating that the details provided by the user were not sufficient to complete the request.
 */
export const ERROR_RCM_PASSWORD_RESET_INSUFFICIENT_DETAILS = 'ERROR_RCM_PASSWORD_RESET_INSUFFICIENT_DETAILS';

/**
 * Error code indicating that the data provided by the user does not conform to the required schema.
 */
export const ERROR_RCM_PASSWORD_RESET_INVALID_REQUEST_SCHEMA = 'ERROR_RCM_PASSWORD_RESET_INVALID_REQUEST_SCHEMA';

/**
 * Error code indicating that the user attempted to use an invalid password reset token.
 */
export const ERROR_RCM_PASSWORD_RESET_INVALID_TOKEN = 'ERROR_RCM_PASSWORD_RESET_INVALID_TOKEN';

/**
 * Error code indicating that the new password provided by the user does not conform to password requirements.
 */
export const ERROR_RCM_PASSWORD_RESET_INVALID_NEW_PASSWORD = 'ERROR_RCM_PASSWORD_RESET_INVALID_NEW_PASSWORD';
